import React, { useContext } from 'react';
import SectionTitle from '../../yourProperties/Title';
import useTranslate from '../../../../customHooks/useTranslate';
import Card from '../../../../muiComponents/Card';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import Title from '../../../components/Title';
import Icon from '../../../../muiComponents/Icon';
import { ContextUserProfile } from '../../../../contexts/UserProfileContext';
import {
    gridColumnsSpacing,
    gridRowsSpacing,
    singleColumnGrid,
} from '../../../../utils/bookings/bookingUtils';
import { formatDate, formatDateTime } from '../../../../utils/formatDates';
import CopyOnHover from '../../components/CopyOnHover';

const MainInformation = props => {
    const {
        bookingCode,
        hotelRefecerenceCode,
        bookingDate,
        checkIn,
        checkOut,
        customerName,
        customerEmail,
        nights,
        paxes,
    } = props;
    const title = useTranslate('main_information');
    const { translate, timeZone, language } = useContext(ContextUserProfile);

    return (
        <section className='booking__section'>
            <SectionTitle text={title} />
            <Card className='padding20'>
                <Grid
                    style={{ width: 'auto', margin: 0 }}
                    columnSpacing={gridColumnsSpacing}
                    rowSpacing={gridRowsSpacing}
                >
                    <GridChild gridProps={singleColumnGrid}>
                        <div className='flex-column gap-5'>
                            <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                <Icon
                                    iconName='Newspaper'
                                    className='text-secunday700'
                                />
                                <Title className='text-capitalize'>
                                    {translate('booking_code')}
                                </Title>
                            </div>
                            <CopyOnHover textToCopy={bookingCode}>
                                <p>{bookingCode || '----'}</p>
                            </CopyOnHover>
                        </div>
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <div className='flex-column gap-5'>
                            <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                <Icon
                                    iconName='Newspaper'
                                    className='text-secunday700'
                                />
                                <Title className='text-capitalize'>
                                    {translate('booking_reference_hotel')}
                                </Title>
                            </div>
                            <CopyOnHover textToCopy={hotelRefecerenceCode}>
                                <p>{hotelRefecerenceCode || '----'}</p>
                            </CopyOnHover>
                        </div>
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <div className='flex-column gap-5'>
                            <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                <Icon
                                    iconName='EventNote'
                                    className='text-secunday700'
                                />
                                <Title>{translate('booking_date')}</Title>
                            </div>
                            <p>
                                {bookingDate
                                    ? formatDateTime(
                                          bookingDate,
                                          language,
                                          timeZone
                                      )
                                    : '--/--/----'}
                            </p>
                        </div>
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <div className='flex-column gap-5'>
                            <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                <Icon
                                    iconName='Today'
                                    className='text-secunday700'
                                />
                                <Title className='text-capitalize'>
                                    {translate('check_in_out')}
                                </Title>
                            </div>
                            <p>
                                {checkIn ? formatDate(checkIn) : '--/--/----'} -
                                {checkOut ? formatDate(checkOut) : '--/--/----'}
                            </p>
                        </div>
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <div className='flex-column gap-5'>
                            <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                <Icon
                                    iconName='DateRange'
                                    className='text-secunday700'
                                />
                                <Title className='text-capitalize'>
                                    {translate('nights')}
                                </Title>
                            </div>
                            <p>{nights || '----'}</p>
                        </div>
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <div className='flex-column gap-5'>
                            <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                <Icon
                                    iconName='People'
                                    className='text-secunday700'
                                />
                                <Title className='text-capitalize'>
                                    {translate('guests')}
                                </Title>
                            </div>
                            <p>{paxes || '----'}</p>
                        </div>
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <div className='flex-column gap-5'>
                            <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                <Icon
                                    iconName='Person'
                                    className='text-secunday700'
                                />
                                <Title className='text-capitalize'>
                                    {translate('customer')}
                                </Title>
                            </div>
                            <p>{customerName || '----'}</p>
                        </div>
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <div className='flex-column gap-5'>
                            <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                <Icon
                                    iconName='Email'
                                    className='text-secunday700'
                                />
                                <Title className='text-capitalize'>
                                    {translate('customer_email')}
                                </Title>
                            </div>
                            <CopyOnHover textToCopy={customerEmail}>
                                <p>{customerEmail || '----'}</p>
                            </CopyOnHover>
                        </div>
                    </GridChild>
                </Grid>
            </Card>
        </section>
    );
};

export default MainInformation;
